"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Discussion = babelHelpers.interopRequireDefault(require("components/Discussion"));

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _userProfile = require("user-profile");

var _EventActivityHeader = require("EventActivityHeader");

var _class, _descriptor, _descriptor2, _descriptor3, _temp, _class3, _descriptor4, _descriptor5, _descriptor6, _temp2;

var DiscussionHeader = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(DiscussionHeader, _Component);

  function DiscussionHeader() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, DiscussionHeader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(DiscussionHeader)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "node", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "selectNotificationById", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "allNotifications", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(DiscussionHeader, [{
    key: "render",
    value: function render() {
      var Type = require("discussionHeader.".concat(this.node.discussionHeader.type)).default;

      return _react.default.createElement(Type, {
        header: this.node.discussionHeader,
        node: this.node,
        selectNotificationById: this.selectNotificationById,
        allNotifications: this.allNotifications
      });
    }
  }]);
  return DiscussionHeader;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "node", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "selectNotificationById", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "allNotifications", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
var ApplicationViewer = (_class3 = (_temp2 =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(ApplicationViewer, _Component2);

  function ApplicationViewer() {
    var _babelHelpers$getProt2;

    var _this2;

    babelHelpers.classCallCheck(this, ApplicationViewer);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(ApplicationViewer)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this2, "item", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "selectNotificationById", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "allNotifications", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    _this2.state = {
      userProfile: null
    };
    return _this2;
  }

  babelHelpers.createClass(ApplicationViewer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;

      (0, _userProfile.getUserProfile)().then(function (value) {
        return _this3.setState({
          userProfile: value
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.userProfile) {
        return _react.default.createElement("div", {
          className: "application-viewer"
        }, _react.default.createElement(DiscussionHeader, {
          node: this.item,
          selectNotificationById: this.selectNotificationById,
          allNotifications: this.allNotifications
        }), _react.default.createElement(_Discussion.default, {
          discussionRoot: this.item.discussionRoot,
          userId: this.state.userProfile ? this.state.userProfile.id : null,
          commentFormAtEnd: true
        }));
      }

      return null;
    }
  }]);
  return ApplicationViewer;
}(_react.Component), _temp2), (_descriptor4 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "item", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "selectNotificationById", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "allNotifications", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class3);
exports.default = ApplicationViewer;